import { Filter } from '@/interfaces/filter.interface'
import { APIProduct } from '@/models/api/product.model'
import { ProductsServices } from '@/services/modules/products.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class ProductsStore extends VuexModule {
    products: object[] = []
    productsPaginate: object[] = []
    productForm: object|null = null

    @Mutation
    updateProducts (newProducts: object[]) {
        this.products = newProducts
    }

    @Mutation
    updateProductsPaginate (newProducts: object[]) {
        this.productsPaginate = newProducts
    }

    @Mutation
    updateProduct (newProduct: object) {
        this.productForm = newProduct
    }

    @Action
    getProducts () {
        return new Promise((resolve) => {
            ProductsServices.getProducts()
                .then(resp => {
                    store.commit('updateProducts', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getProductsPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit, sortBy: params.sortBy, sort: params.sort }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            ProductsServices.getProductsPaginate(newParams)
                .then(resp => {
                    store.commit('updateProductsPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getProductsById (id: number) {
        return new Promise((resolve) => {
            ProductsServices.getProductsById(id)
                .then(resp => {
                    store.commit('updateProduct', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editProducts (params: APIProduct) {
        params = new APIProduct(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIProduct)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ProductsServices.editProducts(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createProducts (params: APIProduct) {
        params = new APIProduct(params)

        params.productEnabled = 1

        return new Promise((resolve) => {
            if (!(params instanceof APIProduct)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ProductsServices.createProducts(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteProducts (id: number) {
        return new Promise((resolve) => {
            ProductsServices.deleteProducts(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreProducts (id: number) {
        return new Promise((resolve) => {
            ProductsServices.restoreProducts(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
